import React from "react";
interface HeroProps {
  openCalendly: () => void;
}
export const Hero = ({
  openCalendly
}: HeroProps) => {
  return <section className="w-full bg-gradient-to-br from-indigo-50 to-white pt-20 pb-24 px-6 md:px-12">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center">
        <div className="md:w-3/5 mb-10 md:mb-0 md:pr-10">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 leading-tight">
            Marketing That{" "}
            <span className="text-indigo-600">Actually Grows</span> Your
            Business
          </h1>
          <p className="text-lg text-gray-600 mb-8 leading-relaxed">
            Not just another marketing consultant. I partner with you to
            optimize copy, find quality leads, and create growth strategies that
            deliver measurable results.
          </p>
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
            <a href="#packages" className="bg-indigo-600 text-white px-8 py-3 rounded-md text-center font-medium hover:bg-indigo-700 transition-colors">
              View Packages
            </a>
            <a href="#services" className="border border-indigo-600 text-indigo-600 px-8 py-3 rounded-md text-center font-medium hover:bg-indigo-50 transition-colors">
              Explore Services
            </a>
          </div>
        </div>
        <div className="md:w-2/5">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">
              Ready to grow?
            </h3>
            <p className="text-gray-600 mb-6">
              Book a free 30-minute strategy call to discuss your goals.
            </p>
            <button onClick={openCalendly} className="block w-full bg-indigo-600 text-white px-6 py-3 rounded-md text-center font-medium hover:bg-indigo-700 transition-colors">
              Schedule Your Call
            </button>
          </div>
        </div>
      </div>
    </section>;
};